import Visitors from '../components/templates';

export const VisitsContainer = () => {
  return <Visitors />;
};
